var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M547.092 427.48H128.166V355.531H592.741V381.807C592.741 407.043 572.304 427.48 547.092 427.48Z",
    fill: "#09081A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M433.658 449.999C451.619 449.999 466.18 435.438 466.18 417.476C466.18 399.514 451.619 384.953 433.658 384.953C415.696 384.953 401.135 399.514 401.135 417.476C401.135 435.438 415.696 449.999 433.658 449.999Z",
    fill: "#09081A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.077 449.999C308.039 449.999 322.6 435.438 322.6 417.476C322.6 399.514 308.039 384.953 290.077 384.953C272.116 384.953 257.555 399.514 257.555 417.476C257.555 435.438 272.116 449.999 290.077 449.999Z",
    fill: "#202020"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.406 449.999C170.367 449.999 184.928 435.438 184.928 417.476C184.928 399.514 170.367 384.953 152.406 384.953C134.444 384.953 119.883 399.514 119.883 417.476C119.883 435.438 134.444 449.999 152.406 449.999Z",
    fill: "#09081A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M539.937 449.999C557.899 449.999 572.46 435.438 572.46 417.476C572.46 399.514 557.899 384.953 539.937 384.953C521.975 384.953 507.414 399.514 507.414 417.476C507.414 435.438 521.975 449.999 539.937 449.999Z",
    fill: "#202020"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M613.901 344.287V378.914C613.901 397.088 599.19 411.799 581.016 411.799H577.598V401.049C577.598 390.434 573.298 380.793 566.327 373.844C559.289 366.783 549.534 362.483 538.761 362.574C517.509 362.777 500.671 380.77 500.671 402.044V411.799H328.099V401.049C328.099 390.434 323.799 380.793 316.85 373.844C309.812 366.806 300.035 362.483 289.284 362.574C268.01 362.777 251.171 380.77 251.171 402.044V411.799H112.503C97.8594 411.799 86 399.94 86 385.296V369.25C86 366.172 88.4896 363.683 91.5676 363.683H93.514V323.397C93.514 319.255 96.8862 315.883 101.051 315.883H118.432C119.949 313.054 122.936 311.153 126.354 311.153H198.868L251.035 256.269L251.307 255.975L255.72 251.335C256.512 250.475 257.644 250 258.798 250H556.98C563.815 250 569.994 254.096 572.664 260.388L595.093 313.303L595.546 314.389C596.949 319.617 600.299 324.098 604.78 326.95C609.963 330.232 613.108 335.867 613.765 341.91C613.855 342.702 613.901 343.494 613.901 344.287Z",
    fill: "url(#paint0_linear_4939_694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M359.94 260.389L328.141 308.573C327.1 310.18 325.29 311.153 323.389 311.153H198.865L251.033 256.27H357.722C359.849 256.27 361.117 258.623 359.94 260.389Z",
    fill: "#09081A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M429.153 311.153H349.464C346.725 311.153 345.028 308.166 346.454 305.789L373.454 260.796C375.129 257.99 378.184 256.27 381.443 256.27H418.945L424.875 288.159L429.153 311.153Z",
    fill: "#09081A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M504.405 311.153H438.183L433.408 285.556L427.953 256.27H494.198L496.077 266.409L504.405 311.153Z",
    fill: "#09081A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M560.124 311.153H513.434L504.63 263.783L503.227 256.27H551.66C555.621 256.27 559.151 258.782 560.464 262.516L571.757 294.745C574.564 302.756 568.612 311.153 560.124 311.153Z",
    fill: "#09081A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343.647 250L302.207 311.153H272.581L219.237 411.799H112.503C97.8594 411.799 86 399.94 86 385.296V369.25C86 366.172 88.4896 363.683 91.5676 363.683H93.514V323.397C93.514 319.255 96.8862 315.883 101.051 315.883H118.432C119.949 313.054 122.936 311.153 126.354 311.153H198.868L251.035 256.269L251.307 255.975L255.72 251.335C256.512 250.475 257.644 250 258.798 250H343.647Z",
    fill: "url(#paint1_linear_4939_694)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.215 357.252H193.525C191.149 357.252 189.384 355.079 189.859 352.771L194.544 329.573C194.906 327.83 196.422 326.562 198.21 326.562H248.703V332.764C248.703 346.298 237.749 357.252 224.215 357.252Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.929 326.562H180.174C182.799 326.562 184.927 328.69 184.927 331.315V367.55C184.927 370.175 182.799 372.303 180.174 372.303H113.929C111.303 372.303 109.176 370.175 109.176 367.55V331.315C109.153 328.69 111.303 326.562 113.929 326.562Z",
    fill: "#09081A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5371 326.562H105.781V357.252H93.5371",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M128.166 316.941H219.239",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M257.555 330.887L264.978 323.645H582.918",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5371 363.684H257.554",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M500.785 398.332H327.986",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M597.788 398.332H577.486",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M251.285 398.332H101.82",
    stroke: "#09081A",
    strokeWidth: 2.65424,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M613.901 344.287V369.182H613.765C607.699 369.182 602.766 364.248 602.766 358.183V352.91C602.766 346.844 607.699 341.91 613.765 341.91C613.855 342.702 613.901 343.494 613.901 344.287Z",
    fill: "#067244"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M539.936 436.243C550.298 436.243 558.698 427.843 558.698 417.481C558.698 407.119 550.298 398.719 539.936 398.719C529.574 398.719 521.174 407.119 521.174 417.481C521.174 427.843 529.574 436.243 539.936 436.243Z",
    fill: "#F2F2F2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M290.079 436.243C300.441 436.243 308.841 427.843 308.841 417.481C308.841 407.119 300.441 398.719 290.079 398.719C279.717 398.719 271.316 407.119 271.316 417.481C271.316 427.843 279.717 436.243 290.079 436.243Z",
    fill: "#F2F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M322.598 323.645C332.171 323.645 582.915 323.645 582.915 323.645C582.915 323.645 588.258 328.994 592.964 336.002C602.008 349.469 600.365 379.003 600.365 379.003H582.915H330.519L322.598 323.645Z",
    fill: "url(#paint2_linear_4939_694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4939_694",
    x1: 349.95,
    y1: 248.381,
    x2: 349.95,
    y2: 416.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FFFBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5017,
    stopColor: "#05D585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B06B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4939_694",
    x1: 335.612,
    y1: 330.899,
    x2: 147.798,
    y2: 330.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4939_694",
    x1: 461.491,
    y1: 311.287,
    x2: 461.491,
    y2: 377.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1893,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2469,
    stopColor: "#00110A",
    stopOpacity: 0.2787
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5185,
    stopColor: "#015D39",
    stopOpacity: 0.1782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#02945B",
    stopOpacity: 0.095
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9099,
    stopColor: "#02B670",
    stopOpacity: 0.0333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02C378",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuv);
export default __webpack_public_path__ + "static/media/SUV.3877effd.svg";
export { ForwardRef as ReactComponent };